import React, { FC, useEffect, useMemo } from 'react'
import { useForm } from 'react-hook-form'

import { FormInput } from 'components/FormWithGroup'
import { CountryCodeAutocomplete } from '..'
import { getRegisterLabelOptions } from 'modules/Labels/constants'

import { ICreateLabel, LabelFormProps } from './LabelForm.props'
import './LabelForm.scss'

const LabelForm: FC<LabelFormProps> = ({ countryOptions, onSubmit, defaultValues, isUpdate }) => {
  const { control, handleSubmit, reset } = useForm<ICreateLabel>({ defaultValues })
  const registerLabelOptions = useMemo(() => getRegisterLabelOptions(isUpdate), [isUpdate])

  useEffect(() => {
    reset(defaultValues)
  }, [reset, defaultValues])

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="label-form" id="label-form">
      <h4 className="label-form__title">{isUpdate ? 'Zone info' : 'Add New Zone'}</h4>
      <div className="sbx-row sbx-row-gutter-20">
        <div className="sbx-col-lg-8 sbx-col-sm-12 sbx-col-xs-24">
          <FormInput
            fieldName="name"
            control={control}
            rules={registerLabelOptions.name}
            placeholder="Name"
            label="Name"
          />
        </div>
        <div className="sbx-col-lg-8 sbx-col-sm-12 sbx-col-xs-24">
          <FormInput
            fieldName="alias"
            control={control}
            rules={registerLabelOptions.alias}
            placeholder="Alias"
            label="Key"
          />
        </div>
        <div className="sbx-col-lg-8 sbx-col-sm-12 sbx-col-xs-24">
          <FormInput
            fieldName="max_radio_stations"
            control={control}
            rules={registerLabelOptions.max_radio_stations}
            placeholder="Maximum number of radio stations"
            label="Maximum number of radio stations"
          />
        </div>
        <div className="sbx-col-lg-8 sbx-col-sm-12 sbx-col-xs-24">
          <CountryCodeAutocomplete
            control={control}
            rules={registerLabelOptions.country_codes}
            countryOptions={countryOptions}
            label="Chart Countries"
          />
        </div>
      </div>
    </form>
  )
}

export default LabelForm
